export const calcWindowHeight = (fixedheight: number) => {
  return window.innerHeight - fixedheight
}
